import axios from "axios";
import React, { useState } from "react";
import { useEffect } from "react";
import Table from "react-bootstrap/Table";
import moment from "moment";

function Log() {
  const id = JSON.parse(window.localStorage.getItem("logId"));
  const [catatan, setcatatan] = useState(false);

  const getNote = async () => {
    const result = await axios.get(`https://mobile.amospa.com/note/user/${id}`);
    setcatatan(result.data.data.reverse());
  };
  
  useEffect(() => {
    getNote();
  }, []);

  return (
    <Table striped bordered hover className="mt-4" style={{overflow:'scroll'}}>
      <thead>
        <tr>
          <th>NO</th>
          <th>Staff</th>
          <th>Keterangan</th>
          <th>Note</th>
          <th>Date</th>
        </tr>
      </thead>
      <tbody>
        {catatan ? (
          catatan.map((item, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td>{item.staffName}</td>
              <td>{item.keterangan}</td>
              <td>{item.catatan}</td>
              <td>{moment(item.createdAt).parseZone().format('DD-MM-YYYY')}</td>
            </tr>
          ))
        ) : (
          <tr></tr>
        )}
      </tbody>
    </Table>
  );
}

export default Log;
